<div class="modal-container">
  <div class="modal-header" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
    <h5 style="margin-left: 8px;">Edit Referral</h5>
    <button mat-icon-button mat-dialog-close aria-label="Close dialog" style="background-color: rgba(0, 0, 0, 0);" class="custom-mat-field">
        <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <!-- [hidden] instead of *ngIf so both steps stay alive (form state, calculator state, ViewChild resets) -->
    <div class="step-panel" [hidden]="activeStep !== 'debts'">
        <div class="tab-scroll-content">
            <form [formGroup]="formlyForm">
                <formly-form
                [form]="formlyForm"
                [fields]="formlyFields"
                [model]="data"></formly-form>
            </form>
        </div>
    </div>
    <div class="step-panel" [hidden]="activeStep !== 'calculator'">
        <div class="tab-scroll-content">
            <div class="step-actions">
                <button mat-stroked-button color="primary" (click)="goToDebts()">
                    <mat-icon>arrow_back</mat-icon> Back to Debts
                </button>
                <button mat-stroked-button color="primary" mat-dialog-close>
                    <mat-icon>close</mat-icon> Close
                </button>
            </div>
            <div *ngIf="isSahaCalculator; else noSaha">
                <button style="margin-left: 15px; margin-bottom: 8px;" mat-raised-button color="primary" *ngIf="showRefresh" (click)="verifyWaiveOff()">Refresh</button>
                <app-loancalculator/>
            </div>
            <ng-template #noSaha>
                <app-old-loan-calculator/>
            </ng-template>
        </div>
    </div>
  </div>
</div>